import appCONST from 'constants/app.constants';

export default function HotelRoomDetailsService(
    $http
) {
    'ngInject';

    Object.assign(this, {
        getRoomDetails,
    });

    function getRoomDetails(roomId, hotelId, searchId) {
        const endpoint = `${appCONST.apiUrl}/hotels/getroomdetails`;
        const params = {
            roomId,
            hotelId,
            searchId,
        };

        return $http.get(endpoint, {params})
            .then(({data}) => data);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-room/hotel-room-details/hotel-room-details-service.js